import { UserPermission } from './Types';

export const DEFAULT_ROLE_READ_PERMISSIONS = Object.values(UserPermission)
  .filter((permission) => permission.endsWith('_READ'));

export const ensureDefaultRoleReadPermissions = (permissions: string[] = []) => (
  Array.from(new Set([...permissions, ...DEFAULT_ROLE_READ_PERMISSIONS]))
);
